// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1b82f9be","455":"6e3cdd68"}[chunkId] + ".chunk.js";
};